<div id="really-click-modal" class="{{modalFade}} {{modalClass}} {{backdropClass}}" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Confirm</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{reallyClickService.message}}</p>
      </div>
      <div class="modal-footer" *ngIf="!reallyClickService.hasCustomButtons">
        <button type="button" class="btn btn-raised btn-light" (click)="decline()"> Cancel</button>
        <button type="button" class="btn btn-raised btn-primary" (click)="accept()">Yes, Confirm</button>
      </div>
      <div class="modal-footer" *ngIf="reallyClickService.hasCustomButtons">
        <button type="button" class="btn btn-raised btn-light" (click)="decline()">Cancel</button>
        <button *ngFor="let button of reallyClickService.buttons" type="button" class="btn btn-raised btn-primary"
          (click)="invoke(button)">{{button.text}}</button>
      </div>
    </div>
  </div>
</div>